import { configureStore } from '@reduxjs/toolkit';
import { combineReducers, type UnknownAction } from 'redux';
import draftStore from './draft.store';
import globalItemsStore from './globalItems.store';
import postReplyDraftStore from './postReplyDraft.store';
import postReplyDraftsStore from './postReplyDrafts.store';
import replyDraftsStore from './replyDrafts.store';
import userStore from './user.store';
import userAvatarStore from './userAvatar.store';
import userPreferencesStore from './userPreferences.store';

const appReducer = combineReducers({
  userStore,
  userAvatarStore,
  userPreferencesStore,
  draftStore,
  postReplyDraftStore,
  postReplyDraftsStore,
  globalItemsStore,
  replyDraftsStore,
});

type RootState = ReturnType<typeof appReducer>;

const rootReducer = (
  state: RootState | undefined,
  action: UnknownAction,
): RootState => {
  if (action.type === 'auth/logout') {
    // Return undefined so every slice falls back to its initialState.
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;
